<div class="flex px-8 py-3 items-center justify-between border-b border-inherit">

  <div class="text-xl font-bold tracking-tight">
    {{ 'Filtro' | transloco }}
  </div>

  <button mat-icon-button [svcTestId]="closeButtonTestId" (click)="close()" class="-mr-2">
    <mat-icon class="text-current" svgIcon="mat_solid:close"></mat-icon>
  </button>

</div>

<div class="overflow-y-auto flex-auto p-5">
  <svc-filters
    #svcFilters
    [svcTestId]="filtersTestId"
    [hidden]="isLoading"
    [filters]="filters"
    [useFirstMondayRule]="useFirstMondayRule"
    (onValueChanged)="onFilterValueChanged.emit($event)"
    (onFilterChanged)="checkIfHasFiltersToDo($event)"
  ></svc-filters>

  <div *ngIf="isLoading" [svcTestId]="loadingTestId" class="flex flex-col p-10 items-center">
    <mat-spinner diameter="35"></mat-spinner>
  </div>

</div>

<div class="flex flex-row px-5 py-4 items-center justify-center border-t border-inherit gap-2">
  <button
    svc-btn
    [svcTestId]="clearButtonTestId"
    id="filter-sidebar-clear"
    [disabled]="isLoading || (!hasFiltersDefined && svcFilters?.isTotallyEmpty)"
    (click)="internalClearFilters()"
  >
    {{ 'Limpar filtros' | transloco }}
  </button>
  <button
    svc-filled-btn
    [svcTestId]="searchButtonTestId"
    id="filter-sidebar-search"
    [disabled]="isLoading || (searchOnlyWhenHaveNewValues && !hasFiltersPending) || !svcFilters?.isValid"
    (click)="search()"
  >
    {{ 'Buscar' | transloco }}
  </button>
</div>
